export enum UIActionType {
  SET_CURRENT_NETWORK = "SET_CURRENT_NETWORK",
  RESET_UI_DATA = "RESET_UI_DATA",
  SET_APP_LOADING = "SET_APP_LOADING",
  SET_FIRST_APP_LOADING = "SET_FIRST_APP_LOADING",
  SET_SNACKBAR = "SET_SNACKBAR",
  SET_NETWORK = "SET_NETWORK",
  SET_DATA_LOADINGS = "SET_DATA_LOADINGS",
}
